const selectData = ( arr, item, value, return_type )=> {
    return_type = return_type ?? null;
    let process;
    if(return_type === "filter"){
        process = return_type
    }else{
        process = "find";
    }
    if(Array.isArray(arr)){
        return arr.find(( element, key )=>{
            if(element[item] === value){
                if(return_type === "key"){
                    return key;
                }
                return element;
            }
        })
    }
    return [];
}


export {selectData}